export default __webpack_public_path__ + "static/media/elevate-swarovski-poster-3.4b8fa5bf.jpg";